<template>
    <CreateCourse/>
</template>

<script>
import CreateCourse from '../../../components/Admin/Courses/Createcourse/createcourse.vue'
export default{
    data(){
        return{

        }
    }, 
    components:{
        CreateCourse
    }
}
</script>